import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core'; // OnDestroy hinzugefügt
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/modules/auth/services/auth/auth.service';
import { SubscriptionService } from 'src/app/modules/feature-toggle/services/subscription.service';
import { LoaderService } from '../../core/services/loader/loader.service';
import { filter, takeUntil } from 'rxjs/operators'; // takeUntil hinzugefügt
import { CompanySettingsService } from 'src/app/modules/settings/services/company-settings.service';
import { Subject } from 'rxjs'; // Subject hinzugefügt
import { UserPermissionsService } from 'src/app/modules/employee/services/user-permissions.service';
import { CommonModule } from '@angular/common';
import { XdsTooltipDirective, XdsProgressComponent } from 'src/app/shared/ui';
import { TopActionsBarComponent } from '../top-actions-bar/top-actions-bar.component';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.css'],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        XdsTooltipDirective,
        XdsProgressComponent,
        TopActionsBarComponent
    ]
})
export class PageHeaderComponent implements OnInit, OnDestroy {
  // OnDestroy implementiert
  currentRoute: string;
  isRegisteredStepper: boolean = false;
  public loading = false;
  public isMenuCollapsed = true;
  private destroy$ = new Subject<void>(); // Für takeUntil

  constructor(
    public authService: AuthService,
    public router: Router,
    public loaderService: LoaderService,
    private changeDetectorRef: ChangeDetectorRef,
    public subscriptionService: SubscriptionService,
    public companySettingsService: CompanySettingsService,
    public userPermissions: UserPermissionsService,
  ) {}

  ngOnInit(): void {
    // this.changeDetectorRef.detach(); // Kann oft entfernt werden, wenn Änderungen sauber erkannt werden
    this.loaderService.isLoading
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.loading = res > 0;
        this.changeDetectorRef.detectChanges(); // Sicherstellen, dass die View aktualisiert wird
      });

    this.subscriptionService
      .loadCompanyFeatures()
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        // Typ NavigationEnd verwenden
        this.currentRoute = event.urlAfterRedirects || event.url; // urlAfterRedirects für den Fall von Redirects
        this.isRegisteredStepper =
          this.currentRoute.includes('registered-stepper');
        this.changeDetectorRef.detectChanges();
      });
  }

  isOpen(): void {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    // Sichtbarkeit über [class.show] am collapse-Container; der Klick-Event triggert die CD.
  }

  // Navigationsmethoden (vereinfacht mit tryNavigate)
  private tryNavigate(url: string): void {
    this.router.navigateByUrl(url);
    this.isMenuCollapsed = true;
  }

  onDashboardClick(): void {
    this.tryNavigate('/dashboard');
  }
  onEmployeeDashboardClick(): void {
    this.tryNavigate('/employeedashboard');
  }
  onEmployeeClick(): void {
    this.tryNavigate('/employee');
  }
  onTimeRecordingClick(): void {
    this.tryNavigate('/time-recording');
  }
  onAbsenceClick(): void {
    this.tryNavigate('/absence');
  }
  onPlannerClick(): void {
    this.tryNavigate('/planner');
  }
  onAvailabilityClick(): void {
    this.tryNavigate('/availability');
  }
  onResourcePlanClick(): void {
    this.tryNavigate('/staffing-management');
  }
  onSettingsClick(): void {
    this.tryNavigate('/settings');
  }
  onDashboardClickImage(): void {
    this.tryNavigate(
      this.authService.isManegeOrTeamLeader
        ? '/dashboard'
        : '/employeedashboard'
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
